<template>
  <button
    class="burger"
    :class="getClasses"
    @click="$emit('toggle-sidebar')"
    aria-label="Открыть меню"
  >
    <span></span>
    <span></span>
    <span></span>
  </button>
</template>

<script>

export default {
  name: 'MainHeader',
  props: {
    isOpenSidebar: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getClasses () {
      return { 'burger--active': this.isOpenSidebar }
    }
  }
}
</script>

<style lang="scss" src="./style.scss" />
